import { render, staticRenderFns } from "./EmojiIcon.vue?vue&type=template&id=24bec82c&"
import script from "./EmojiIcon.vue?vue&type=script&lang=ts&"
export * from "./EmojiIcon.vue?vue&type=script&lang=ts&"
import style0 from "./EmojiIcon.vue?vue&type=style&index=0&id=24bec82c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports